import React from "react";

import Modal from "../Model";

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
  title?: string;
}

const VideoModal: React.FC<VideoModalProps> = ({
  isOpen,
  onClose,
  videoUrl,
  title = "Video Preview",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} style="w-[90%] max-w-4xl">
      <div className="flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold">{title}</h2>
        </div>
        <div className="relative w-full aspect-video bg-black rounded-lg overflow-hidden">
          <video
            src={videoUrl}
            controls
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    </Modal>
  );
};

export default VideoModal;
